import "./ButtonRound.scss";
import { useState } from "react";

const ButtonRound = ({
  onClick,
  iconImg,
  alt,
  backgroundColor,
  backgroundColorHover,
  isLeft,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <button
      className={`button-round ${isLeft ? "button-round--left" : ""}`}
      onClick={onClick}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      style={{
        backgroundColor: hover ? backgroundColorHover : backgroundColor,
      }}
    >
      <img className="button-round__image" src={iconImg} alt={alt} />
    </button>
  );
};

export default ButtonRound;
